import type { TreeApi } from "@hogartrabe/react-arborist-vrh";
import type { Node } from "interfaces/schemas";

export const redrawList = (treeApi: TreeApi<Node>, index: number) => {
  treeApi.redrawList(index);
  // Reset the index to a default of 0 to ensure the list is redrawn from the beginning.
  return 0;
};
